<div class="flex flex-col gap-6">
	<h2>Datos Generales</h2>
	<div class="border rounded-md bg-gray-100 p-5 flex flex-col gap-5">
		@if (profile(); as profile) {
		<div class="flex gap-5">
			@if (!isCompany()) {
					<div class="w-full">
						<div>Nombre</div>
						<div class="font-semibold">{{profile.firstName}}</div>
						
					</div>
					<div class="w-full">
						<div>Apellido</div>
						<div class="font-semibold">{{profile.lastName}}</div>
						
					</div>
				} @else {
					<div class="w-full">
						<div>Razón Social</div>
						<div class="font-semibold">{{profile.companyName}}</div>
					</div>
				}
			</div>

			<div class="flex gap-5">
				<div class="w-full">
					<div>Email</div>
					<div class="font-semibold">{{profile.email}}</div>
					
				</div>
				@if (profile.identification) {
					<div class="w-full">
						<div>{{ isCompany() ? 'CUIT' : 'DNI' }}</div>
						<div class="font-semibold">{{formattedIdentification()}}</div>

					</div>
				}
			</div>

			<div class="flex gap-5">
				@if (profile.address) {
					<div class="w-full">
						<div>Dirección</div>
						<div class="font-semibold">{{profile.address}}</div>
					</div>
				}
				@if (profile.postalCode && profile.postalCode !== 'undefined') {
					<div class="w-full">
						<div>Código Postal</div>
						<div class="font-semibold">{{profile.postalCode}}</div>
			
					</div>
				}
			</div>

			@if (profile.birthDate) {
				<div class="flex gap-5">
					<div class="w-full">
						<div>Fecha de Nacimiento</div>
						<div class="font-semibold">{{profile.birthDate | date: 'dd/MM/yyyy'}}</div>
					</div>
				</div>
			}

			@if (isAgent()) {
				<div class="flex gap-5">
					<div class="w-full">
						<div>Matrícula</div>
						<div class="font-semibold">{{profile.insuranceNumberArgentina}}</div>
					</div>
					<div class="w-full">
						<div>Código en Meridional</div>
						<div class="font-semibold">{{profile.insuranceNumberMeridional}}</div>
					</div>
				</div>
			}
		}

	</div>
	
</div>
